import { Badge, Box, Center, Flex, Text, Link } from '@chakra-ui/react';
import { MdCheckCircle } from 'react-icons/md';
import { IoIosAlert } from 'react-icons/io';
import {
  getSlugFromPath,
  truncateStringWithEllipsis,
} from '../../utils/helpers';

const ContactItem = (props) => {
  if (props.type == 'social') {
    //console.log(props);
    return (
      <Box borderRadius="xl">
        <Box
          px={3}
          backgroundColor="transparent"
          mx={3}
          // my={3}
          py={2}
        >
          <Flex justifyContent="space-between">
            <Box display="flex" justifyContent="center" alignItems="center">
              <Text color="#FFF" fontSize={12} ps={2} fontWeight={500}>
                {props.socialType} {':'}
              </Text>

              <Link
                href={props.socialLink}
                target="_blank"
                color="#FFF"
                fontSize={12}
                ps={2}
                fontWeight={500}
              >
                {`/${truncateStringWithEllipsis(getSlugFromPath(props.socialLink))}`}
              </Link>
            </Box>
            <Box>
              <Badge
                backgroundColor="transparent"
                // borderRadius={30}
                color="white"
                borderRadius="full"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                {props.type == 'email' ? (
                  props.emailStatus ? (
                    <MdCheckCircle color="orange" fontSize={14} />
                  ) : (
                    <IoIosAlert color="red" fontSize={14} />
                  )
                ) : (
                  props.phoneType
                )}
              </Badge>
            </Box>
          </Flex>
        </Box>
      </Box>
    );
  } else {
    return (
      <Box borderRadius="xl">
        <Box
          px={3}
          backgroundColor="transparent"
          mx={3}
          // my={3}
          py={2}
        >
          <Flex justifyContent="space-between">
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box fontSize={14}>{props.icon}</Box>

              <Text color="#FFF" fontSize={12} ps={2} fontWeight={500}>
                {props.type == 'email' ? props.email : props.phoneNumber}
              </Text>
            </Box>
            <Box>
              <Badge
                backgroundColor="transparent"
                // borderRadius={30}
                color="white"
                borderRadius="full"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                {props.type == 'email' ? (
                  props.emailStatus ? (
                    <MdCheckCircle color="orange" fontSize={14} />
                  ) : (
                    <IoIosAlert color="red" fontSize={14} />
                  )
                ) : (
                  props.phoneType
                )}
              </Badge>
            </Box>
          </Flex>
        </Box>
      </Box>
    );
  }
};
export default ContactItem;
